import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CreateUserBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const createUser = createApiThunk<string, CreateUserBody>("admin/users/createUser", async (body, { extra: { adminRepository } }) => {
  return adminRepository!.createUser(body);
});

export const resetCreateUser = createAction("admin/users/resetCreateUser");
